// extracted by mini-css-extract-plugin
export default {"custom-mac-input-container":"macInput_custom-mac-input-container__jtsHA","mac-inp":"macInput_mac-inp__z5czt"};